import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { useRoute } from "vue-router";
import { useFullWindow4to3RatioDimensionStyle } from "@/composables/screen";
import LiveBaseImage from "@/views/partials/components/LiveBaseImage.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'PublicLiveImage',
  setup(__props) {

const route = useRoute();
const fullWindow4to3RatioDimensionStyle = useFullWindow4to3RatioDimensionStyle();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    style: _normalizeStyle(_unref(fullWindow4to3RatioDimensionStyle))
  }, [
    _createVNode(LiveBaseImage, {
      cameraId: _unref(route).params.camera_id as string,
      showControls: false,
      isPublic: true
    }, null, 8, ["cameraId"])
  ], 4))
}
}

})